'use strict';

var AbstractTableRowView = Marionette.ItemView.extend({
    template: require('components/common/templates/abstract_table_row'),
    tagName: 'tr',

    initialize: function (options) {
        this.columns = options.columns;
        this.hasSelectionButtons = options.hasSelectionButtons;

        // attributes are not updated dynamically when calling "render",
        // e.g. when a table row is selected -> use explicit callback.
        this.listenTo(this, 'dom:refresh', this.updateAttributes);
    },

    attributes: function () {
        return {
            class: this.model.selected ? 'selected' : '',
            'data-row-id': this.model.id,
        };
    },

    updateAttributes: function () {
        this.$el.attr(this.attributes());
    },

    serializeData: function () {
        var data = Marionette.LayoutView.prototype.serializeData.apply(this, arguments);

        data.columns = this.columns;
        data.hasSelectionButtons = this.hasSelectionButtons;
        data.isSelected = this.model.selected;
        data.isSelectable = this.model.selectable === undefined ? true : this.model.selectable;
        data.isHighlighted = this.model.get('highlighted') === true;
        data.context = this.options.context;
        data.id = this.model.id;

        return data;
    },

    remove: function () {
        var self = this;
        this.$el.fadeOut(function () {
            Marionette.ItemView.prototype.remove.call(self);
        });
    },
});

module.exports = AbstractTableRowView;
